<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Dashboard</h3>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-card>
                <v-card-title primary-title style="background:darkgreen;color: white;">
                  <div>
                    <h4 class="headline mb-0">Wards</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->

                <v-card-text style="background:darkgreen;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">people</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{myWards.length}}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions style="background: #fafafa;color:#333">
                  <p>Total number of your children/wards</p>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card>
                <v-card-title primary-title style="background:darkblue;color: white;">
                  <div>
                    <h4 class="headline mb-0">Total Wards Fees</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background:darkblue;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">money</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{otot_bill?otot_bill:0|toCurrency}}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions style="background: #fafafa;color:#333">
                  <p>overall sum of fees for all wards</p>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card>
                <v-card-title primary-title style="background:darkslategray;color: white;">
                  <div>
                    <h4 class="headline mb-0">Total Wards Arrears</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background:darkslategray;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">money</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{otot_arrears?otot_arrears:0|toCurrency}}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions style="background: #fafafa;color:#333">
                  <p>overall sum of arrears for all wards</p>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  layout: "guardian",
  mounted() {
    this.$store.dispatch("guardians/myWards");

  },
  data() {
    return {
      otot_bill: 0,
      otot_arrears: 0
    };
  },
  methods: {
    discount(disc, bsum) {
      if (disc) {
        if (disc.val_type == "percentage") {
          return parseFloat(bsum) * (disc.val / 100);
        } else {
          return disc.val;
        }
      } else {
        return 0;
      }
    },
    tot_paid(ward) {
      let tp = ward.s_payments
        ? ward.s_payments.reduce((sum, val) => {
            return sum + parseFloat(val.amount);
          }, 0)
        : 0;

      return tp;
    },

    c_bill(ward) {
      let bmt = ward.s_class.feestr
        ? parseFloat(ward.s_class.feestr.basic_amt)
        : 0;
      let ac_sum = ward.s_class.feestr
        ? ward.s_class.feestr.adcharges.reduce((sum, val) => {
            return sum + parseFloat(val.amount);
          }, 0)
        : 0;

      let ttl = bmt + ac_sum;

      //console.log(ttl)
      return ttl;
    }
  },
  computed: {
    ...mapGetters({
      myWards: "guardians/GUARDIAN_WARDS",
      gloading: "guardians/GUARDIAN_LOADING",
      gerrors: "guardians/GUARDIAN_ERROR",
    })
  },

  watch: {
    myWards(val) {
      if (val) {
        let m = val.map(w => {
          let wdisc = w.s_discount
          let cb = this.c_bill(w); //wards class bill
          let td = this.discount(wdisc,cb); //wards discount
          let tp = this.tot_paid(w); //wards total paid
          let warr = w.fees_arrears?w.fees_arrears:0 //current student arrears
          let resbill = (parseFloat(cb)+parseFloat(warr))-parseFloat(td) //resolved bill..take out discount and report this rest as individual student fee charge


          let final_arrears = parseFloat(resbill) - parseFloat(tp)

            //console.log("uuuu",final_arrears)
          return {
            ward_id: w.id,
            tpaid: tp,
            tarrears: final_arrears,
            cbill:resbill
          }
        })

        //console.log(m)

       this.otot_bill = m.reduce((sum,val)=>{
         //console.log(val)
         return sum+parseFloat(val.cbill)
       },0)

        this.otot_arrears =  m.reduce((sum,val)=>{
         return sum+parseFloat(val.tarrears)
       },0)

       //console.log(this.otot_bill)
       //console.log(this.otot_arrears)

       //this.otot_arrears = parseFloat(this.otot_bill)-parseFloat(ototpaid)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/guardian/dashboard.vue